import React, { Component } from 'react';

import CommonService from '../../services/commonService';
import PropTypes from 'prop-types';
import { KuposModal } from '../common';
import getIcons from '../themes/functions/getIcons/getIcons';

const getSeatIcon = (seat, petSeats) => {
  if (petSeats && petSeats[seat.number]) {
    if (!seat.isGangWay && seat.isReservable && seat.number && !seat.isSelected) {
      return 'icon-pet-seat_available';
    } else if (!seat.isGangWay && seat.isReservable && seat.isSelected) {
      return 'icon-pet-seat_selected';
    } else if (!seat.isGangWay && !seat.isReservable) {
      return 'icon-pet-seat_occupied';
    }
  }
  if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.number &&
    !seat.isSelected &&
    seat.number &&
    (seat.type.toUpperCase().indexOf('EJECUTIVO') > -1 ||
      seat.type.toUpperCase().indexOf('CLASICO') > -1)
  ) {
    return 'icon-executive-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.number &&
    (seat.type.toUpperCase().indexOf('EJECUTIVO') > -1 ||
      seat.type.toUpperCase().indexOf('CLASICO') > -1)
  ) {
    return 'icon-executive-seat_selected';
  } else if (
    !seat.isGangWay &&
    !seat.isReservable &&
    seat.number &&
    (seat.type.toUpperCase().indexOf('EJECUTIVO') > -1 ||
      seat.type.toUpperCase().indexOf('CLASICO') > -1)
  ) {
    return 'icon-executive-seat_occupied';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    !seat.isSelected &&
    seat.type.toUpperCase() == 'PREMIUM'
  ) {
    return 'icon-vip-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.type.toUpperCase() == 'PREMIUM'
  ) {
    return 'icon-vip-seat_selected';
  } else if (!seat.isGangWay && !seat.isReservable && seat.type.toUpperCase() == 'PREMIUM') {
    return 'icon-vip-seat_occupied';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    !seat.isSelected &&
    seat.type.toUpperCase().indexOf('SALON CAMA') > -1
  ) {
    return 'icon-salon-cama-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.type.toUpperCase().indexOf('SALON CAMA') > -1
  ) {
    return 'icon-salon-cama-seat_selected';
  } else if (
    !seat.isGangWay &&
    !seat.isReservable &&
    seat.type.toUpperCase().indexOf('SALON CAMA') > -1
  ) {
    return 'icon-salon-cama-seat_occupied';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    !seat.isSelected &&
    seat.type.toUpperCase().indexOf('SEMI CAMA') > -1
  ) {
    return 'icon-semi-bed-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.type.toUpperCase().indexOf('SEMI CAMA') > -1
  ) {
    return 'icon-semi-bed-seat_selected';
  } else if (
    !seat.isGangWay &&
    !seat.isReservable &&
    seat.type.toUpperCase().indexOf('SEMI CAMA') > -1
  ) {
    return 'icon-semi-bed-seat_occupied';
  } else if (seat.number == 'DR_IMG') {
    return 'icon-steering';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    !seat.isSelected &&
    seat.type.toUpperCase() == 'CAMA PREMIUM'
  ) {
    return 'icon-vip-seat_available';
  } else if (
    !seat.isGangWay &&
    seat.isReservable &&
    seat.isSelected &&
    seat.type.toUpperCase() == 'CAMA PREMIUM'
  ) {
    return 'icon-vip-seat_selected';
  } else if (!seat.isGangWay && !seat.isReservable && seat.type.toUpperCase() == 'CAMA PREMIUM') {
    return 'icon-vip-seat_occupied';
  }
};

const getSeatTypeName = seat => {
  if (!seat.isGangWay && seat.isReservable && seat.number && !seat.isSelected && seat.number) {
    return 'available';
  } else if (!seat.isGangWay && seat.isReservable && seat.isSelected && seat.number) {
    return 'selected';
  } else if (!seat.isGangWay && !seat.isReservable && seat.number) {
    return 'occupied';
  }
};

export default class CoachLayout extends Component {
  static propTypes = {
    selectedService: PropTypes.object,

    metaData: PropTypes.object,
    coachLayout: PropTypes.array,
    upperAvalibility: PropTypes.bool,
    selectedSeatsToBook: PropTypes.array,
    onFloorChange: PropTypes.func,
    selectedFloor: PropTypes.any,
    onSeatSelect: PropTypes.func,
    t: PropTypes.func,
  };

  seatMouseoverDivEl = [];
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalTitle: '',
      modalBody: '',
      showButton1: true,
      buttonText1: '',
    };
  }

  seatRow = () => {
    let rows = this.props.coachLayout.map((row, i) => (
      <ul key={i + Math.random()}>{this.seatCol(row)}</ul>
    ));
    return rows;
  };

  seatCol = row => {
    let cols = row.map((seat, i) => {
      // console.log('Seat is ------------', seat);
      return !(
        seat.isGangWay ||
        seat.isBreak ||
        (seat.number && (seat.number.indexOf('GY') > -1 || seat.number.indexOf('gy') > -1))
      ) && seat.object.floor_no === this.props.selectedFloor ? (
        this.seatItem(seat, i)
      ) : (
        <li key={i + Math.random()} className="gw">
          {' '}
        </li>
      );
    });
    return cols;
  };

  getSeatName = rawSeat => {
    console.log('Raw seat internal moore-----------'.rawSeat);
    switch (rawSeat) {
      case 'SALON CAMA':
        return 'Salón Cama';
        break;
      case 'CLASICO':
        return 'Clásico';
        break;
      case 'Clasico':
        return 'Clásico';
        break;
      case 'Salon Sin Vent':
        return 'Salón Sin Vent';
        break;
      case 'SALON SIN VENT':
        return 'Salón Sin Vent';
        break;
      case 'Salon Preferente':
        return 'Salón Preferente';
        break;
      case 'SALON PREFERENTE':
        return 'Salón Preferente';
        break;
      case 'SALON':
        return 'Salón ';
        break;
      case 'Salon':
        return 'Salón ';
        break;
      default:
        return CommonService.capitalize(rawSeat);
        break;
    }
  };

  isPetSeatPair = seat => {
    for (let p in this.props.petSeats) {
      let sNo = this.props.petSeats[p].find(it => it == seat.number);
      if (sNo) {
        let seats = [];
        for (let row of this.props.coachLayout) {
          if (!seats[0]) seats[0] = row.find(it => it.number == this.props.petSeats[p][0]);
          if (!seats[1]) seats[1] = row.find(it => it.number == this.props.petSeats[p][1]);
        }
        return seats;
      }
    }
    return null;
  };

  seatItem = (seat, i) => {
    const operator = CommonService.getLocal('op');
    return seat.number ? (
      <li
        rowSpan={seat.rowSpan}
        colSpan={seat.colSpan}
        className={getSeatTypeName(seat) + ' ' + getSeatIcon(seat).split('_')[0]}
        key={i + Math.random()}
        onClick={() => {
          let petPair = this.isPetSeatPair(seat);
          let confirmTicketData = sessionStorage.getItem('confirmTicketData');

          console.log({ petPair, seat });
          if (petPair) {
            if (confirmTicketData) return;
            if (!seat.isSelected)
              this.setState({
                showModal: true,
                modalTitle: '',
                modalBody: 'Pet seat Popup',
                showButton1: true,
                buttonText1: this.props.t('RESULTS_PAGE.CONTINUE'),
              });

            this.props.onSeatSelect(
              CommonService.selectPetSeat(
                petPair[0],
                petPair[1],
                this.props.metaData,
                this.props.coachLayout,
                this.props.selectedSeatsToBook,
                this.props.selectedService && this.props.selectedService.route,
                this.props.isMot
              ),
            );
          } else {
            this.props.onSeatSelect(
              CommonService.selectSeat(
                seat,
                this.props.metaData,
                this.props.coachLayout,
                this.props.selectedSeatsToBook,
                this.props.selectedService && this.props.selectedService.route,
                operator,
                this.props.isMot
              ),
            );
          }
        }}
      >
        {/* <img src={getSeatIcon(seat)}/> */}

        <style>
          .seat-mousover {'{'}
          background-color:{' '}
          {operator && operator.color_codes && operator.color_codes.secondary_color
            ? operator.color_codes.secondary_color
            : '#ff5c60'}
          ;{'}'}
          .seat-mousover .primary-triangle {'{'}
          border-top: 20px solid{' '}
          {operator && operator.color_codes && operator.color_codes.secondary_color
            ? operator.color_codes.secondary_color
            : '#ff5c60'}
          ;{'}'}
        </style>

        {getSeatIcon(seat) != 'icon-steering' ? (
          <span className="seat-number bold-text">
            {seat.number != 'DR_IMG' ? seat.number : ''}
          </span>
        ) : null}
        {getSeatIcon(seat) != 'icon-steering' ? (
          <div className={'seat-sprite ' + getSeatIcon(seat, this.props.petSeats)}>
            <div
              className={seat.object.available && 'seat-mousover mouseover-popups font9 nowrap'}
              key={seat.object.number}
              ref={el => {
                this.seatMouseoverDivEl[seat.object.number] = el;
              }}
              style={{
                marginLeft:
                  '-' +
                  (this.seatMouseoverDivEl[seat.object.number]
                    ? this.seatMouseoverDivEl[seat.object.number].clientWidth / 2
                    : 0) +
                  'px',
              }}
            >
              {seat.object.available ? (
                <div>
                  <div>
                    {this.props.t('CANCEL_TICKET.SEAT_NUMBER')}: {seat.object.number}
                  </div>
                  <div>
                    {this.props.t('CANCEL_TICKET.FARE')}: CLP{' '}
                    {
                      CommonService.currency(seat.object.net_amount || seat.object.fare).split(
                        ',',
                      )[0]
                    }
                  </div>
                  <div>
                    {this.props.t('RESULTS_PAGE.SEAT_TYPE')}:{' '}
                    {CommonService.capitalize(this.getSeatName(seat.object.type))}
                  </div>
                  <span className="primary-triangle"></span>
                </div>
              ) : null}
            </div>
          </div>
        ) : null}
      </li>
    ) : null;
  };

  onFloorChange = floor => {
    this.props.onFloorChange(floor);
    setTimeout(() => {
      this.setState({});
    }, 250);
  };

  getTabs = operator => {
    let tabs = [];
    for (let i = 0; i < 2; i++) {
      tabs.push(
        <a
          key={i}
          className={this.props.selectedFloor === i ? 'active bold-text' : ''}
          // onClick={() => {this.onFloorChange('lower')}}
          style={
            this.props.selectedFloor === i &&
            operator &&
            operator.color_codes &&
            operator.color_codes.secondary_color
              ? { backgroundColor: operator.color_codes.secondary_color }
              : null
          }
          onClick={() => {
            this.onFloorChange(i);
          }}
        >
          {'Piso #' + (i + 1)}
        </a>,
      );
    }
    return tabs;
  };

  render() {
    let { t } = this.props;
    const operator = CommonService.getLocal('op');
    const expresosantacruz =  operator.operator_name === "expresosantacruz" 
    const trrass  = operator.operator_name === "trrass"
    const cormarbus = operator.operator_name === "cormarbus"
    console.log('coach layout ', this.props);
    return (
      <div className="pb-service-list-coach-layout">
        <div className="flex-row floor-buttons-row ">
          <div className="font10">
            {this.props.upperAvalibility ? (
              <div className="floor-buttons white-text flex-row ">{this.getTabs(operator)}</div>
            ) : null}
          </div>
          <div className="flex-row legends-row font10">
            <div className="flex-row legend">
              <div className="legend-color available"></div>
              <div className="legend-label dark-text">{t('RESULTS_PAGE.SEAT_AVAILABLE')}</div>
            </div>
            <div className="flex-row legend">
              <div className="legend-color selected"></div>
              <div className="legend-label dark-text">{t('RESULTS_PAGE.SEAT_SELECTED')}</div>
            </div>
            <div className="flex-row legend">
              <div className="legend-color reserved"></div>
              <div className="legend-label dark-text">{t('RESULTS_PAGE.SEAT_OCCUPIED')}</div>
            </div>
          </div>
        </div>
        <div
          className={
            'coach-layout-container kupos-border seats-in-coach ' +
            (this.props.selectedFloor === 0 ? 'lower' : '')
          }
        >
          {this.props.selectedFloor == 0 ? (
            <div className="driver">
              <img src="/static/images/seats/icon-steering.png" alt="" />
              <div className="top-line"></div>
              <div className="bottom-line"></div>
            </div>
          ) : null}
          <div
            className={
              'coach-table light-text ' +
              (this.props.upperAvalibility ? '' : 'optimize-seat-spacing')
            }
          >
            {this.props.coachLayout ? this.seatRow(1) : null}
          </div>
        </div>
      <div className='red-text mt-2 mb-2 font9'>{this.props.motMaxSeatError && this.props.t('PASSENGER_DETAILS.MOT_MAX_SEATS')}</div>

        <KuposModal
          size="lg"
          showModal={this.state.showModal}
          title={this.state.modalTitle}
          bodyText={this.state.modalBody}
          type="alert"
          showButton1={true}
          buttonText1={this.state.buttonText1}
          onButtonClick1={() => this.setState({ showModal: false })}
          showButton2={false}
          buttonTextStyle={{ fontSize: 15 }}
          onHide={() => this.setState({ showModal: false })}
          showClose={true}
          noBackground
        >
          {/* <div className="" style={expresosantacruz || trrass || cormarbus ? {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
          } : {}}>
            <div className="pet-modal-icon" style={expresosantacruz || trrass || cormarbus  ? {
              display: 'flex',
              justifyContent: 'center',
            } : {}}
            >
              <img src={getIcons('petseatModal', operator)} alt="" style={expresosantacruz || trrass || cormarbus  ? { width: '50%' } : {}} />
            </div> */}
            <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center', 
    }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f5f5f5',
               padding: '30px', 
               borderRadius: '20px',
               width: '50%',
               height: 'auto',
               paddingBottom: '30px',}}>
              <img src={getIcons('petseatref', operator)} alt="" style={{width:80,height:80}} />
            <div className="pet-modal-title bold-text font12"
            style={{paddingTop: '20px',paddingBottom: '20px',}}>
              <span>¡Información importante!</span>
            </div>
            <div className="pet-modal-subtitle  font10"
            style={{paddingBottom: '20px',}}>
            Seleccionaste un <strong>asiento mascota o pet friendly</strong>. Por favor considera que:
            </div>
            <div className="pet-modal-list"
            style={{textAlign:'justify'}}>
              <div className="pet-modal-list-item font10"
              style={{paddingBottom:10}}> 
                <span>
                 Solo pueden viajar perros y gatos en un canil o bolso transportador que no exceda los 40 cm de largo, 40 cm de ancho y 40 cm de alto.
                </span>
              </div>
              <div className="pet-modal-list-item font10"
               style={{paddingBottom:10}}>
                <span> El asiento mascota o pet friendly se vende junto con el asiento de al lado o contiguo.</span>
              </div>
              <div className="pet-modal-list-item font10"
               style={{paddingBottom:10}}>
                <span>
                  Solo podrá viajar una (1) mascota por pasajero.
                </span>
              </div>
              <div className="pet-modal-list-item font8"
               style={{paddingBottom:10}}>
                <span>
                 Al continuar, estas declarando conocer y cumplir con los términos y condiciones para viajar con mascotas.
                </span>
              </div>
            </div>
            <div
              className="pet-modal-button font12"
              style={{ display: 'flex', justifyContent: 'center',marginTop: '30px' }}
            >
              <button
                className="kupos-button"
                onClick={() => this.setState({ showModal: false })}
                type="onSubmit"
                style={{
                  backgroundColor:
                    operator && operator.color_codes && operator.color_codes.button_color
                      ? operator.color_codes.button_color
                      : '',
                }}
              >
                <span>{t('HOME.OK_CONTINUE')}</span>
              </button>
            </div>
          </div>
          </div>
        </KuposModal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/pb-service-list/CoachLayout.js